import { connect } from 'react-redux'
import { compose } from 'recompose'

import {
  makesPaginatedQueries,
  pageAndDataFetched,
  resetList,
  fetchPageStart,
  fetchPageError,
} from 'data/graphql'

import { fetchAllTemplateNotes as fetchAllTemplateNotesQuery } from 'remote/notes'

import { selectors as NotesSelectors } from 'data/notes'

const LIST_NAME = NotesSelectors.ALL_TEMPLATE_NOTES_LIST_NAME

const fetchAllTemplateNotes = ({ resetOnUnmount = false } = {}) =>
  compose(
    connect(
      state => ({
        listState: NotesSelectors.getAllTemplateNotesListState(state),
      }),
      {
        pageAndDataFetched,
        resetList,
        fetchPageStart,
        fetchPageError,
      }
    ),
    makesPaginatedQueries({
      resetOnUnmount,
      query: fetchAllTemplateNotesQuery,
      getVariables: ({ listState }) => ({ options }) => {
        const endCursor =
          listState && !options.startFresh ? listState.pageInfo.endCursor : null
        return {
          pagination: {
            first: 100,
            after: endCursor,
          },
        }
      },
      getOnReset: ({ resetList }) => () => resetList(LIST_NAME),
      getOnFetchStart: ({ fetchPageStart }) => ({ meta }) =>
        fetchPageStart(LIST_NAME, meta),
      getOnFetchSuccess: ({ pageAndDataFetched }) => ({ result, options }) => {
        const connection = result.data.showAllTemplateNotes
        pageAndDataFetched(LIST_NAME, connection, options)
      },
      getOnFetchError: ({ fetchPageError }) => error =>
        fetchPageError(LIST_NAME, error),
    })
  )
export default fetchAllTemplateNotes
